<template>
    <div class="app-info">
      <h1 class="app-name">欢迎来到蛛网X！</h1>
  
      <section class="section">
        <h2 class="section-title">简介：</h2>
        <p class="section-content">
          蛛网X是一款集视频处理与编辑功能于一身的创新应用，我们致力于为用户提供简单、高效、专业的视频处理解决方案。无论您是需要转换视频格式、生成实况照片、提取音频还是制作GIF动图，蛛网X都能为您提供强大的支持。
        
        <br><br>我们的使命是通过先进的技术和用户友好的界面，让每一个人都能轻松实现视频编辑梦想。我们深知在这个数字时代，视频内容的创作和分享变得越来越重要。因此，我们不断优化和创新，力求为用户提供最佳的使用体验和最优质的服务。</p>
      </section>
  
      <section class="section">
        <h2 class="section-title">我们的核心功能：</h2>
        <ul class="section-content">
          <li>视频转码： 支持多种格式转换，确保视频在各种设备上的兼容性。</li>
          <li>视频转实况：将普通视频转换为实况照片，增加分享的趣味性。</li>
          <li>提取音频：从视频中提取音频，方便制作音频资源。</li>
          <li>视频转GIF：轻松将视频片段转化为动态GIF，打造有趣视觉效果。</li>

        </ul>
      </section>
      
      
      <section class="section">
        <h2 class="section-title">为什么选择蛛网X？</h2>
        <ul class="section-content">
          <li class="highlight">易用性：</li>
          <p>简洁友好的用户界面，即使是新手也能轻松上手。</p>
  
          <li class="highlight">高性能：</li>
          <p>强大的处理能力，保证视频处理速度和质量。</p>
          <li class="highlight"> 持续更新：</li>
          <p>定期更新和新增功能，确保你总能使用到最新的技术和特性。</p>
          <li class="highlight">安全可靠：</li>
          <p>【快存】严格遵守隐私和数据安全规定，确保用户的个人信息和下载内容不会被泄露。</p>
         
        </ul>
      </section>
      <section class="section">
        <h2 class="section-title">联系我们：</h2>
        <p class="section-content">
          如果您在使用过程中有任何疑问或建议，欢迎随时与我们联系。我们非常重视用户的反馈，并将不断改进和提升产品功能。
          <br>QQ:1971715546
          <br>邮箱:17320177064@163.com
</p>
      </section>
     
      <p class="conclusion">
        感谢您选择蛛网X，期待与您共同创造更多精彩内容！
      </p>
    </div>
  </template>
  
  <script>
  export default {
    created() {
        document.title = "关于我们"

    },
    name: "AppInfo",
  };
  </script>
  
  <style scoped>
 
  .app-name {
    color: #333;
    font-size: 24px;
    margin-bottom: 20px;
  }
  
  .section {
    margin-bottom: 20px;
  }
  
  .section-title {
    color: #333;
    font-size: 20px;
    margin-bottom: 10px;
  }
  
 
  
  .highlight {
    color: #333;
    font-weight: bold;
  }
  
  .conclusion {
    margin-top: 20px;
    font-size: 18px;
  }
  .app-info {
  margin: 5px;
  text-align: left; /* 左对齐 */
}





.conclusion {
  margin-top: 20px;
  font-size: 18px;
  text-align: left; /* 左对齐 */
}
  </style>
  